module.exports = __webpack_public_path__ + "static/media/laborum.40446bd6.svg";